// Gestão de consentimento (LGPD). Essenciais são sempre permitidos (o jogo não
// funciona sem o localStorage de progresso e a infraestrutura Firebase). A
// categoria "analytics" é opt-in: o Google Analytics só carrega DEPOIS que o
// usuário aceita. A decisão é persistida no próprio localStorage do usuário —
// nenhum dado pessoal é coletado aqui.

export interface ConsentState {
  /** Sempre true — necessário para o jogo funcionar. */
  essential: true;
  /** Analytics (Google Analytics). Opt-in. */
  analytics: boolean;
  /** Timestamp da decisão (para versionar/expirar consentimento no futuro). */
  decidedAt: number;
}

const KEY = 'winiverso_consent_v1';

export function getConsent(): ConsentState | null {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.analytics !== 'boolean') return null;
    return { essential: true, analytics: parsed.analytics, decidedAt: parsed.decidedAt ?? 0 };
  } catch {
    return null;
  }
}

export function hasDecided(): boolean {
  return getConsent() !== null;
}

export function setConsent(analytics: boolean): ConsentState {
  const state: ConsentState = { essential: true, analytics, decidedAt: Date.now() };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    /* ignora se o storage estiver indisponível */
  }
  return state;
}
